module.exports = __webpack_public_path__ + "img/icon_instagram_reel.7c5612e7.svg";